var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormIconValid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38A157",
    fillRule: "nonzero",
    d: "M11 22a11 11 0 110-22 11 11 0 010 22zm0-21a10 10 0 100 20 10 10 0 000-20z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#38A157",
    strokeLinecap: "round",
    d: "M6 12l3 3 7-7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIconValid);
export default __webpack_public_path__ + "static/media/form-icon-valid.d92bba1d19cdea50c1f7d34d989c555f.svg";
export { ForwardRef as ReactComponent };